import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./index.css";

// Alt+click an element to open its source; the runtime and its data
// attributes exist only in the dev build.
if (import.meta.env.DEV) {
  void import("@locator/runtime").then((locator) => locator.default());
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Missing #root element");

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
